// plugins/vue-i18n.js
import { createI18n } from 'vue-i18n'

export default defineNuxtPlugin(nuxtApp => {
    const i18n = createI18n({
        legacy: false,
        locale: 'en', // 기본 언어 설정
        messages: {
            en: {
                welcome: "Welcome (en)",
            },
            ko: {
                welcome: "환영합니다 (ko)",
            }
        }
    })
    nuxtApp.vueApp.use(i18n)
})